import { Row, Col, Alert } from 'react-bootstrap'
import styled from 'styled-components'
import CategoryToggle from 'components/CategoryToggle'
import Panel from 'components/Panel'
import InlineLoader from 'components/InlineLoader'
import Faqs from 'containers/FaqList/Faqs'
import Button from 'components/Button'
import { HelpfulTopicsContainer } from 'containers'

const List = styled.ul`
  list-style-type: none;
  padding: 0;
`

const PanelTitle = styled.span`
  display: inline-block;
  margin-right: 10px;
`

const FaqList = (props) => {
  const {
    handleClick,
    currentCategory,
    currentSubcat,
    currentFaq,
    isFetching,
    deviceId,
    icon,
    categories,
    jumpToManuals,
    productNameSingular = ''
  } = props

  const productName = productNameSingular.toLowerCase() || 'device'

  const manualsExist = () => categories.find((c) => c.name === 'User Guides')

  const subcats = (category) =>
    category.children.map((subcat) => {
      const active = subcat.PK === currentSubcat
      return (
        <li key={subcat.name}>
          <CategoryToggle
            title={subcat.name}
            active={active}
            icon={icon(subcat.name)}
            handleClick={handleClick.bind(this, 'currentSubcat', subcat.PK)}
          >
            <List>
              <Faqs
                category={subcat.PK}
                handleClick={handleClick}
                currentFaq={currentFaq}
              />
            </List>
          </CategoryToggle>
        </li>
      )
    })

  const categoryList = () =>
    categories.map((cat) => {
      const active = cat.PK === currentCategory
      const showSubcat =
        cat.children.length > 1 || cat.children[0].name !== cat.name
      return (
        <li key={cat.PK}>
          <CategoryToggle
            title={cat.name}
            active={active}
            icon={icon(cat.name)}
            handleClick={handleClick.bind(this, 'currentCategory', cat.PK)}
          >
            {showSubcat && <List>{subcats(cat)}</List>}

            {!showSubcat && (
              <List>
                <Faqs
                  category={cat.children[0].PK}
                  handleClick={handleClick}
                  currentFaq={currentFaq}
                />
              </List>
            )}
          </CategoryToggle>
        </li>
      )
    })

  const content = () => {
    if (isFetching) {
      return <InlineLoader />
    }

    if (!deviceId) {
      return (
        <Alert bsStyle="info">
          Please select a {productName} from {productName} search to view FAQs.
        </Alert>
      )
    }

    if (!categories.length) {
      return (
        <Alert bsStyle="warning">
          No FAQs found for current {productName}.
        </Alert>
      )
    }

    return <List>{categoryList()}</List>
  }

  const faqsTitle = (
    <div>
      <PanelTitle>FAQs</PanelTitle>
      {manualsExist() && (
        <Button onClick={jumpToManuals}>Jump to Manuals</Button>
      )}
    </div>
  )

  return (
    <Row>
      <Col xs={12} md={9}>
        <Panel title={faqsTitle}>
          {content()}
        </Panel>
      </Col>

      <Col xs={12} md={3}>
        <HelpfulTopicsContainer />
      </Col>
    </Row>
  )
}

export default FaqList
